var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFatigueSliderIcon5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 113.39 113.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1-fatigue-slider,.cls-2-fatigue-slider,.cls-3-fatigue-slider{fill:none;}.cls-2-fatigue-slider,.cls-3-fatigue-slider{stroke:#fff;stroke-width:3px;}.cls-2-fatigue-slider{stroke-linecap:round;stroke-linejoin:round;}.cls-3-fatigue-slider{stroke-miterlimit:10;}.cls-4-fatigue-slider{clip-path:url(#clip-path);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-fatigue-slider",
    x: 79.13,
    y: 44.27,
    width: 17.81,
    height: 6.61
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2-fatigue-slider",
    d: "M53.62,56.15A16.65,16.65,0,0,0,46.55,56a10.94,10.94,0,0,0-5.1,3.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3-fatigue-slider",
    d: "M16.41,94.22s-.75-9.75,0-14.63S20.34,70,24.47,68.72,35,65.53,40.22,66.09l5.25.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3-fatigue-slider",
    d: "M75.51,94.22s.75-9.75,0-14.63S71.58,70,67.45,68.72,57,65.53,51.7,66.09l-5.25.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3-fatigue-slider",
    d: "M48.9,36.12A12.26,12.26,0,0,1,32.53,44a26.69,26.69,0,0,0-.19,3c0,10.89,6.45,19.72,14.41,19.72S61.15,57.9,61.15,47a26.51,26.51,0,0,0-.61-5.65,12.62,12.62,0,0,1-1.51.1A12.27,12.27,0,0,1,48.9,36.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3-fatigue-slider",
    d: "M23.54,69.08A49,49,0,0,1,22,56.69c0-19.41,11-35.15,24.47-35.15S70.92,37.28,70.92,56.69a49.07,49.07,0,0,1-1.68,12.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3-fatigue-slider",
    d: "M53.58,67.66c0,4.3-3.19,7.78-7.13,7.78S39.33,72,39.33,67.66"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2-fatigue-slider",
    x1: 28.97,
    y1: 81.28,
    x2: 28.97,
    y2: 94.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2-fatigue-slider",
    x1: 62.97,
    y1: 81.28,
    x2: 62.97,
    y2: 94.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-fatigue-slider",
    x: 79.03,
    y: 19.97,
    width: 17.81,
    height: 30.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-fatigue-slider",
    x: 82.59,
    y: 13.03,
    width: 10.87,
    height: 6.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2-fatigue-slider",
    x1: 79.03,
    y1: 44.27,
    x2: 96.84,
    y2: 44.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2-fatigue-slider",
    x1: 79.03,
    y1: 50.34,
    x2: 96.84,
    y2: 50.34
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2-fatigue-slider",
    points: "22.86 10.97 29.6 9.13 24.07 18.8 31.67 16.73"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2-fatigue-slider",
    points: "38.22 10.53 43.36 9.13 39.15 16.5 44.94 14.92"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2-fatigue-slider",
    points: "16.07 25.72 21.21 24.33 17 31.69 22.79 30.11"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4-fatigue-slider"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2-fatigue-slider",
    x1: 67.31,
    y1: 26.41,
    x2: 108.75,
    y2: -15.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2-fatigue-slider",
    x1: 67.31,
    y1: 36.41,
    x2: 108.75,
    y2: -5.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2-fatigue-slider",
    x1: 67.31,
    y1: 46.41,
    x2: 108.75,
    y2: 4.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2-fatigue-slider",
    x1: 67.31,
    y1: 56.41,
    x2: 108.75,
    y2: 14.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2-fatigue-slider",
    x1: 67.31,
    y1: 66.41,
    x2: 108.75,
    y2: 24.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2-fatigue-slider",
    x1: 67.31,
    y1: 76.41,
    x2: 108.75,
    y2: 34.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2-fatigue-slider",
    x1: 67.31,
    y1: 86.41,
    x2: 108.75,
    y2: 44.98
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFatigueSliderIcon5);
export default __webpack_public_path__ + "static/media/fatigue_slider_icon_5.3c03985e.svg";
export { ForwardRef as ReactComponent };